module.exports = __webpack_public_path__ + "static/media/image-about-us-Mobile.685e3ce1.png";